export default __webpack_public_path__ + "static/media/ere.1b937030.svg";